
export const typeOptions = [
    { base: 'R', value: 'R-1', text: 'R-1, R-1W, R-3' },
    { base: 'R', value: 'R-2', text: 'R-2' },
    { base: 'IF', value: 'IF', text: 'IF' },
    { base: 'IF/CFO', value: 'IF/CFO', text: 'IF/CFO' },
    { base: 'VF', value: 'VF', text: 'VF' },
    { base: 'VF/CFO', value: 'VF/CFO', text: 'VF/CFO' },
    { base: 'LSW/VF', value: 'LSW/VF', text: 'LSW (VF marked)' },
    { base: 'LSW/IF/CFO', value: 'LSW/IF/CFO', text: 'LSW (IF & CFO marked)' },
    { base: 'LSW/VF/CFO', value: 'LSW/VF/CFO', text: 'LSW (VF & CFO marked)' },
]

export const applicationOptions = [
    {
        type: 'R',
        text: '6mph',
        options: [
            { value: '6-grain-cart', text: 'Combine & Grain Cart' },
            { value: '6-road-transport', text: 'Road Transport' },
            { value: '6-tillage', text: 'Tillage' },
        ],
    },
    {
        type: 'R',
        text: '10mph',
        options: [
            { value: '10-forage-Harvester', text: 'Forage Harvester' },
            { value: '10-general-purpose', text: 'General purpose' },
            { value: '10-grain-cart', text: 'Combine & Grain Cart' },
            { value: '10-haying', text: 'Haying' },
            { value: '10-tillage', text: 'Tillage' },
            { value: '10-planting-seeding', text: 'Planting/seeding' },
            { value: '10-road-transport', text: 'Road Transport' },
        ],
    },
    {
        type: 'R',
        text: '15mph',
        options: [
            { value: '15-road-transport', text: 'Road Transport' },
            { value: '15-spraying', text: 'Spraying' },
        ]
    },
    {
        type: 'R',
        text: '20mph',
        options: [
            { value: '20-road-transport', text: 'Road Transport' },
            { value: '20-spraying', text: 'Spraying' },
        ]
    },
    {
        type: 'R',
        text: '25mph',
        options: [
            { value: '25-road-transport', text: 'Road Transport' },
            { value: '25-spraying', text: 'Spraying' },
        ]
    },
    {
        type: 'R',
        text: '30mph',
        options: [
            { value: '30-road-transport', text: 'Road Transport' },
        ],
    },
    {
        type: 'IF',
        text: 'All',
        options: [
            { value: 'all', text: 'All' },
        ],
    },
    {
        type: 'IF/CFO',
        text: '0 - 10mph',
        options: [
            { value: '10-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'IF/CFO',
        text: '11 - 20mph',
        options: [
            { value: '20-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'IF/CFO',
        text: '0 - 25mph',
        options: [
            { value: '25-general-purpose', text: 'General Purpose' },
            { value: '25-road-transport', text: 'Road Transport' },
        ],
    },
    {
        type: 'VF',
        text: 'All',
        options: [
            { value: 'all', text: 'All' },
        ],
    },
    {
        type: 'VF/CFO',
        text: 'All',
        options: [
            { value: 'general-purpose', text: 'General Purpose' },
        ],
    },
    {
        type: 'VF/CFO',
        text: '0 - 10 mph',
        options: [
            { value: '10-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'VF/CFO',
        text: '11 - 20 mph',
        options: [
            { value: '20-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'LSW/VF',
        text: 'All',
        options: [
            { value: 'general-purpose', text: 'General Purpose' },
        ],
    },
    {
        type: 'LSW/IF/CFO',
        text: 'All',
        options: [
            { value: 'general-purpose', text: 'General Purpose' },
        ],
    },
    {
        type: 'LSW/IF/CFO',
        text: '0 - 10 mph',
        options: [
            { value: '10-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'LSW/IF/CFO',
        text: '11 - 20 mph',
        options: [
            { value: '20-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'LSW/VF/CFO',
        text: 'All',
        options: [
            { value: 'general-purpose', text: 'General Purpose' },
        ],
    },
    {
        type: 'LSW/VF/CFO',
        text: '0 - 10 mph',
        options: [
            { value: '10-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },
    {
        type: 'LSW/VF/CFO',
        text: '11 - 20 mph',
        options: [
            { value: '20-grain-cart', text: 'Combine & Grain Cart' },
        ],
    },

]

export const quantityOptions = [
    { value: 1, text: 'Single' },
    { value: 2, text: 'Duals' },
    { value: 3, text: 'Triples' },
]
